import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { notificationAtom, NotificationType } from '../../atoms/system';
import api from '../../api';
import _ from 'lodash';
import { defaultAuth } from '../../atoms/auth';
import { IResponse } from '../../types';
import { Header } from '../../widgets';
import { useImmer } from 'use-immer';
import { COOKIENAME, LISTURL } from '../../config';
import { Loading } from '../../widgets';
import Cookies from 'js-cookie';

const breadcrumbs = [
  { name: 'Tổng quan', href: LISTURL.general, current: true },
];

type Interaction = {
  review: number;
  reply_review: number;
  question: number;
  reply_question: number;
};

type IProduct = { handle: string; title: string; interaction: Interaction };

type ICustomer = {
  name: string;
  email: string;
  _count: {
    comments: number;
  };
};

type IStatus = {
  active: number;
  pending: number;
  inactive: number;
};

type IGeneral = {
  count: Interaction;
  total_product: number;
  total_customer: number;
  review: IStatus;
  question: IStatus;
  products: IProduct[];
  customers: ICustomer[];
};

type ISynced = {
  total: number;
  synced: number;
};

const General = (): JSX.Element => {
  const notification = useSetAtom(notificationAtom);
  const [loading, setLoading] = useImmer<boolean>(false);
  const [generalData, setGeneralData] = useImmer<IGeneral | null>(null);
  const [synced, setSynced] = useImmer<number>(0);
  const [isLock, setIsLock] = useImmer<boolean>(
    _.isUndefined(Cookies.get(`${COOKIENAME}_syncdata_locked`)) ? false : true,
  );

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await api
          .get(`api/settings/general`)
          .json<IResponse<IGeneral>>();

        const syncData = await api
          .get(`api/settings/data-sync`)
          .json<IResponse<ISynced>>();
        setSynced(syncData.data.synced);

        setGeneralData(result.data);
      } catch (e) {
        console.log(e);
        notification({
          show: true,
          type: null,
          title: null,
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSync = async () => {
    try {
      await api.post(`api/settings/data-sync`);
      Cookies.set(`${COOKIENAME}_syncdata_locked`, '', { expires: 0.25 });
      setIsLock(true);
      notification({
        show: true,
        type: NotificationType.success,
        title: 'Đang tiến hành đồng bộ, thời gian có thể mất đến 30 phút',
      });
    } catch (e) {
      console.log(e);
      notification({
        show: true,
        type: null,
        title: null,
      });
    }
  };

  return (
    <div className="flex flex-col">
      <Header title="Tổng quan" breadcrumbs={breadcrumbs} action={null} />
      <div className="p-3">
        {loading || _.isNull(generalData) ? (
          <div className="flex justify-center items-center min-h-screen">
            <Loading color="indigo-600" size={6} />
          </div>
        ) : (
          <div className="flex flex-col space-y-4">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Tổng sản phẩm
                </span>
                <span className="text-3xl font-bold text-gray-700">
                  {generalData.total_product}
                  <span className="text-sm font-normal text-gray-500">
                    &nbsp;sản phẩm
                  </span>
                </span>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium flex justify-between">
                  Đã đồng bộ
                  {isLock ? null : (
                    <button className="text-indigo-600" onClick={handleSync}>
                      Đồng bộ lại
                    </button>
                  )}
                </span>
                <span className="text-3xl font-bold text-gray-700">
                  {synced}
                  <span className="text-sm font-normal text-gray-500">
                    &nbsp;sản phẩm
                  </span>
                </span>
              </div>
              {/* <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Tổng khách hàng
                </span>
                <span className="text-3xl font-bold text-gray-700">
                  {generalData.total_customer}
                  <span className="text-sm font-normal text-gray-500">
                    &nbsp;khách hàng
                  </span>
                </span>
              </div> */}
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium flex justify-between">
                  Tổng đánh giá
                  <Link to={LISTURL.reviews_list} className="text-indigo-600">
                    Xem chi tiết
                  </Link>
                </span>
                <div className="font-normal text-gray-300">
                  <span className="text-3xl font-bold text-gray-700">
                    {generalData.count.review}
                    <span className="text-sm font-normal text-gray-500">
                      &nbsp;đánh giá
                    </span>
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="text-3xl font-bold text-gray-700">
                    {generalData.count.reply_review}
                    <span className="text-sm font-normal text-gray-500">
                      &nbsp;trả lời
                    </span>
                  </span>
                </div>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium flex justify-between">
                  Tổng câu hỏi
                  <Link to={LISTURL.question_list} className="text-indigo-600">
                    Xem chi tiết
                  </Link>
                </span>
                <div className="font-normal text-gray-300">
                  <span className="text-3xl font-bold text-gray-700">
                    {generalData.count.question}
                    <span className="text-sm font-normal text-gray-500">
                      &nbsp;câu hỏi
                    </span>
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="text-3xl font-bold text-gray-700">
                    {generalData.count.reply_question}
                    <span className="text-sm font-normal text-gray-500">
                      &nbsp;trả lời
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Đánh giá chờ duyệt
                </span>
                <span className="text-3xl font-bold text-yellow-700">
                  {generalData.review.pending}
                </span>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Đánh giá đã duyệt
                </span>
                <span className="text-3xl font-bold text-green-700">
                  {generalData.review.active}
                </span>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Đánh giá tạm ẩn
                </span>
                <span className="text-3xl font-bold text-gray-400">
                  {generalData.review.inactive}
                </span>
              </div>
            </div>
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Câu hỏi chờ duyệt
                </span>
                <span className="text-3xl font-bold text-yellow-700">
                  {generalData.question.pending}
                </span>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Câu hỏi đã duyệt
                </span>
                <span className="text-3xl font-bold text-green-700">
                  {generalData.question.active}
                </span>
              </div>
              <div className="flex flex-1 flex-col bg-white rounded-md p-4 shadow-sm space-y-3">
                <span className="text-sm text-gray-500 font-medium">
                  Câu hỏi tạm ẩn
                </span>
                <span className="text-3xl font-bold text-gray-400">
                  {generalData.question.inactive}
                </span>
              </div>
            </div>
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-1 flex-col space-y-2">
                <h6 className="font-medium text-gray-700 text-md">
                  Sản phẩm được tương tác nhiều
                </h6>
                {generalData.products.length > 0 ? (
                  <ul className="space-y-6 bg-white rounded-md p-6 shadow-sm">
                    {generalData.products.map((item, index) => (
                      <li className="flex flex-wrap" key={index}>
                        <a
                          href={`${defaultAuth?.myharavan_domain}/products/${item.handle}`}
                          className="text-sm block text-blue-600 w-full md:w-2/3"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.title}
                        </a>
                        <span className="flex flex-col w-full md:w-1/3 text-sm text-gray-500 space-y-1">
                          <span>
                            <strong>{item.interaction.review}</strong>&nbsp;đánh
                            giá&nbsp;&nbsp;/&nbsp;&nbsp;
                            <strong>{item.interaction.reply_review}</strong>
                            &nbsp;trả lời
                          </span>
                          <span>
                            <strong>{item.interaction.question}</strong>
                            &nbsp;câu hỏi&nbsp;&nbsp;/&nbsp;&nbsp;
                            <strong>{item.interaction.reply_question}</strong>
                            &nbsp;trả lời
                          </span>
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
              <div className="flex flex-1 flex-col space-y-2">
                <h6 className="font-medium text-gray-700 text-md">
                  Khách hàng tương tác nhiều
                </h6>
                <ul className="space-y-6 bg-white rounded-md p-6 shadow-sm">
                  {generalData.customers.map((item, index) => (
                    <li className="flex flex-wrap" key={index}>
                      <span className="w-full md:w-2/3 flex items-center space-x-2">
                        <span className="text-sm block font-medium text-gray-700">
                          {item.name}
                        </span>
                        <span className="text-xs text-gray-400">
                          ({item.email})
                        </span>
                      </span>
                      <span className="flex flex w-full md:w-1/3 text-sm text-gray-500">
                        <strong>{item._count.comments}</strong>&nbsp;tương tác
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default General;
